export function cancelMeasurementAction() {
  const { t } = useI18n();
  const toolbarStore = useToolbarStore();
  const viewerDistanceMeasurementsStore = useViewerDistanceMeasurementsStore();

  return {
    getTitle: () =>
      t('components.xeokit_viewer.context_menu.cancel_measurement') || 'Cancel Measurement',
    getEnabled: function () {
      const mouseControl = viewerDistanceMeasurementsStore.getMouseControl();
      if (!mouseControl) return;
      return !!mouseControl.currentMeasurement && toolbarStore.measureDistanceMode.active;
    },
    doAction: function () {
      const mouseControl = viewerDistanceMeasurementsStore.getMouseControl();
      if (!mouseControl) return;
      mouseControl.reset();
    },
  };
}
